import { render, staticRenderFns } from "./AgencyContestPanelView.vue?vue&type=template&id=f83b30a4&scoped=true&"
import script from "./AgencyContestPanelView.vue?vue&type=script&lang=js&"
export * from "./AgencyContestPanelView.vue?vue&type=script&lang=js&"
import style0 from "./AgencyContestPanelView.vue?vue&type=style&index=0&id=f83b30a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83b30a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
